import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthPageComponent } from './auth-page/auth-page.component';
import { AuthInvalidGuard } from './guards/auth-invalid.guard';
const authRoutes: Routes = [
    {
        path: 'auth',
        component: AuthPageComponent,
        canActivate: [AuthInvalidGuard]
    }
];

@NgModule({
    imports: [RouterModule.forChild(authRoutes)],
    exports: [RouterModule]
})
export class AuthRoutingModule {}
